export default defineNuxtPlugin((nuxtApp) => {
    const localePath = useLocalePath()

    const $customFetch = $fetch.create({
        onRequest({ request, options, error }) {
            const { token } = useAuth()

            if (token.value) {
                options.headers.set('Authorization', `${token.value}`)
            }
        },
        onResponse({ response }) {
            // response._data = new myBusinessResponse(response._data)
        },
        async onResponseError({ response }) {
            /*if (response.status === 401) {
                const { status, clearToken } = useAuthState()
                const path = localePath('/login')

                if (status.value != 'unauthenticated') {
                    clearToken()
                }

                console.error('Redirecting to', path)
                return nuxtApp.runWithContext(() => navigateTo(path))
            }*/
        },
    })
    // Expose to useNuxtApp().$customFetch
    return {
        provide: {
            customFetch: $customFetch,
        },
    }
})
